import Loading from 'modules/core/components/Loading'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import users from 'modules/core/store/collections/users'

import employees from 'modules/employees/store/collections/employees'

import ImportProcessWizard from './components/ImportProcessWizard'

const ImportProcessPage = () => {
  const { loading } = useAsyncData(
    () =>
      Promise.all([
        employees.fetch({ withCachedFetchParams: true }),
        users.fetch({ withCachedFetchParams: true }),
      ]),
    []
  )

  if (loading) {
    return <Loading />
  }

  return <ImportProcessWizard employees={employees} users={users} />
}

export default ImportProcessPage
